function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Skeleton, List, Typography, Space } from "antd";
import moment from "moment";
import { Excel } from "antd-table-saveas-excel";
import Common from "./includes/Common";
import { Download, PrinterFill } from "react-bootstrap-icons";
import Moment from 'react-moment';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CashierTransactionsList = function CashierTransactionsList(_ref) {
  var _ref$user = _ref.user,
    user = _ref$user === void 0 ? Common.currentUser : _ref$user,
    _ref$dataChanged = _ref.dataChanged,
    dataChanged = _ref$dataChanged === void 0 ? false : _ref$dataChanged,
    _ref$from = _ref.from,
    from = _ref$from === void 0 ? moment().startOf('day').format() : _ref$from,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? moment().endOf('day').format() : _ref$to;
  var _useState = useState(from),
    _useState2 = _slicedToArray(_useState, 2),
    sfrom = _useState2[0],
    setSfrom = _useState2[1];
  var _useState3 = useState(to),
    _useState4 = _slicedToArray(_useState3, 2),
    sto = _useState4[0],
    setSto = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    listOfBills = _useState6[0],
    setListOfBills = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    billsArrayData = _useState8[0],
    setBillsArrayData = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    currentPatient = _useState12[0],
    setCurrentPatient = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    currentItems = _useState14[0],
    setCurrentItems = _useState14[1];
  var _useState15 = useState(user == null ? Common.currentUser : user),
    _useState16 = _slicedToArray(_useState15, 2),
    currentUser = _useState16[0],
    setCurrentUser = _useState16[1];
  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date, row, index) {
      return /*#__PURE__*/_jsx(Moment, {
        date: date,
        format: "DD/MM/YYYY"
      });
    },
    key: "date"
  }, {
    title: "Patient/ETS",
    dataIndex: "patient",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Type",
    dataIndex: "type",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "type"
  }, {
    title: "Acte (s)",
    dataIndex: "acte",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "acte"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "amount"
  }, {
    title: "Cash",
    dataIndex: "cash",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "cash"
  }, {
    title: "Ets",
    dataIndex: "ent",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "ent"
  }, {
    title: "",
    dataIndex: "print",
    render: function render(obj) {
      if (obj.type == "b") return /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          setCurrentItems(obj.items);
          setCurrentPatient(obj.patient);
          printR();
        },
        children: /*#__PURE__*/_jsx(PrinterFill, {
          size: 27
        })
      });else return {
        children: /*#__PURE__*/_jsx("b", {
          children: obj.amount
        })
      };
    },
    key: "print"
  }];
  function printR() {
    var content = document.getElementById("reprintid");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var ref = useRef();
  useEffect(function () {
    setIsDataLoading(true);
    setCurrentUser(user == null ? Common.currentUser : user);
    axios.get(Common.baseApiUrl + "getuserbills/" + from + "/" + to + "/" + currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setListOfBills(response.data.billsdata);
        setBillsArrayData([]);
        var totalDue = 0;
        var cash_amount = 0;
        var post_paid_amount = 0;
        response.data.billsdata.forEach(function (b) {
          var iar = [];
          cash_amount += eval(b.patient_part);
          post_paid_amount += eval(b.company_part);
          b.bill_items.forEach(function (i) {
            if (i.medical_item != null) {
              iar.push(i.medical_item.label);
              //totalDue += i.medical_item.base_price;     
            }
            //cash_amount += b.patient_part;     
            //post_paid_amount += b.company_part;       
          });
          totalDue += eval(b.total_amount);
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: b.id,
              date: b.created_at,
              type: b.company_id == null ? "Part" : "ENT",
              patient: b.company_id == null ? b.customer.firstname + " " + b.customer.lastname : b.company.label + "(" + b.company.rate.toString() + "%)",
              acte: iar.join(", "),
              amount: eval(b.total_amount),
              cash: eval(b.patient_part).toLocaleString("Fr"),
              ent: eval(b.company_part).toLocaleString("Fr"),
              print: {
                type: "b",
                patient: b.customer,
                items: b.bill_items
              }
            }]);
          });
          /*setBillsArrayData(prev => [...prev, { key: b.id, date: new Date(b.created_at).toLocaleDateString("Fr"), 
                                                  type: b.company_id==null ? "Part" : "ENT", 
                                                  patient: b.company_id==null ? b.customer.firstname+" "+b.customer.lastname : b.company.label+"("+b.company.rate.toString()+"%)", 
                                                  acte: iar.join(", "),  
                                                  amount: b.total_amount.toLocaleString("Fr"), 
                                                  cash: cash_amount.toLocaleString("Fr"), 
                                                  ent: post_paid_amount.toLocaleString("Fr"),  
                                                  print: {type: "b", patient : b.customer, items: b.bill_items} }]);     */
        });
        {/*setBillsArrayData(prev => [...prev, { key: "t1", date: "TOTAL (GNF)", type: 0, amount: null, cash: null, ent: null, patient: 0, acte: 0, print:{type: "d", amount: (totalDue).toLocaleString("Fr")}}]);      
         setBillsArrayData(prev => [...prev, { key: "t2", date: "CASH (GNF)", type: 0, amount: null, cash: null, ent: null, patient: 0, acte: 0, print: {type: "d", amount: cash_amount.toLocaleString("Fr")} }]); 
         setBillsArrayData(prev => [...prev, { key: "t3", date: "PRISE EN CHARGE (GNF)", type: 0, amount: null, cash: null, ent: null, patient: 0, acte: 0, print: {type: "d", amount: post_paid_amount.toLocaleString("Fr")} }]); */}
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged, user]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [currentPatient != null && currentItems.length > 0 && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "reprintid",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/logo_sos.jpeg",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date: "
        }), " ", /*#__PURE__*/_jsx(Moment, {
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", currentPatient.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", currentPatient.firstname + " " + currentPatient.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Actes / Produit(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) "
        }),
        bordered: true,
        dataSource: currentItems,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item.medical_item.label + " - " + item.medical_item.base_price.toLocaleString("Fr")
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), currentPatient.company != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + currentPatient.company.rate.toString() + "% par " + currentPatient.company.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepas - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      children: [/*#__PURE__*/_jsx(Button, {
        block: true,
        disabled: billsArrayData.length == 0,
        type: "primary",
        onClick: handleExport,
        style: {
          background: "#34C482"
        },
        icon: /*#__PURE__*/_jsx(Download, {
          size: 28
        }),
        children: /*#__PURE__*/_jsx("b", {
          children: "EXPORTER AU FORMAT EXCEL"
        })
      }), /*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx("div", {
      ref: ref,
      id: "printable",
      children: /*#__PURE__*/_jsx(Table, {
        size: "small",
        columns: cols,
        bordered: true,
        sticky: true,
        loading: isDataLoading,
        dataSource: billsArrayData,
        pagination: false
      })
    }) : /*#__PURE__*/_jsx(Skeleton, {
      active: true
    })]
  });
};
export default CashierTransactionsList;